import { Injectable } from "@angular/core";
import { Tag, TagTranslations } from "../interfaces/tag";
import { LocalizationService } from "src/app/core/services/localization.service";

@Injectable({ providedIn: 'root' })
export class TagParserAdapter {

  constructor(
    private translate: LocalizationService
  ) {}

  adapt(tags: Tag[]) {
    return this.order(tags.map(tag => {
      let lang = this.translate.selectedLanguage;
      lang = lang === 'pt' ? 'pt_br' : lang;

      let name = tag.name;

      if (tag.translations && tag.translations[lang as keyof TagTranslations]) {
        name = tag.translations[lang as keyof TagTranslations];
      }

      return {
        ...tag,
        name,
      };
    }));
  }

  private order(tags: Tag[]) {
    return tags.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }
}

